export class UnifiedDashboardModel {
    createdAt;
    // Numeric user id of the creator. The backend returns the id; the UI resolves the display name.
    createdBy;
    deletedAt;
    deletedBy;
    source;
    id;
    uid;
    projectId;
    projectName;
    title;
    updatedAt;
    updatedBy;
    version;
    icon;
    doc;
    name;
    integration;
    isPrivate;
}
class ProjectModel {
    id;
    name;
    doc;
    createdBy;
    updatedAt;
}
export class ProjectsModel {
    project;
    dashboards;
}
const uniDashboardPattern = /folders\/(?<projectId>[a-z0-9-]+)\/dashboards\/(?<dashboardId>[a-zA-Z0-9_-]+)/;
export const matchUnidashUrlParams = (url) => {
    return url.match(new RegExp(uniDashboardPattern, 'i'));
};
//# sourceMappingURL=unified-dashboards.js.map